import { render, staticRenderFns } from "./Deposit.vue?vue&type=template&id=68b0af6f&scoped=true"
import script from "./Deposit.vue?vue&type=script&lang=js"
export * from "./Deposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b0af6f",
  null
  
)

export default component.exports